// Campos del encabezado; el framework conserva una copia para detectar cambios.
export const form = [
	{
		name: 'account_id',
		value: [],
		valueFull: '',
		id: 'accountreconciliation_form_account_id',
		html: '',
		type: 'autocomplete',
		required: true,
	},
	{
		name: 'date',
		value: '0000-00-00',
		date: true,
		id: 'accountreconciliation_form_date',
		html: '',
		type: 'textfield',
		required: true,
	},
]

export const formCopy = JSON.parse(JSON.stringify(form))
